import createAPI from '@common/createAPI.js'
export default {
  // 查询数据源
  postDatasourceList: config => createAPI('/mbd-dp-manager/datasource/list', 'post', config),
  // 新增数据源
  postDatasourceAdd: config => createAPI('/mbd-dp-manager/datasource/add', 'post', config, {}),
  // 修改数据源
  postDatasourceUpdate: config => createAPI('/mbd-dp-manager/datasource/update', 'post', config, {}),
  // 删除数据源
  postDatasourceDelete: config => createAPI('/mbd-dp-manager/datasource/delete', 'post', config, {}),
  // 获取编码类型
  getEncoding: config => createAPI('/mbd-dp-manager/database/encoding', 'post', config),
  // 根据数据库id获取驱动
  getDrivers: config => createAPI('/mbd-dp-manager/database/drivers', 'post', config),
  // 获取存储类型列表树，不包括驱动
  getDatasourceTypes: config => createAPI('/mbd-dp-manager/database/types', 'post', config),
  // 数据源禁用与启用
  postDatasourceIsEnable: config => createAPI('/mbd-dp-manager/datasource/isEnable', 'post', config),
  // 查询业务库
  postBusinessLibList: config => createAPI('/mbd-dp-manager/businessLib/list', 'post', config),
  // 新增业务库
  postBusinessLibAdd: config => createAPI('/mbd-dp-manager/businessLib/add', 'post', config),
  // 修改业务库
  postBusinessLibUpdate: config => createAPI('/mbd-dp-manager/businessLib/update', 'post', config),
  // 删除业务库
  postBusinessLibDelete: config => createAPI('/mbd-dp-manager/businessLib/delete', 'post', config),
  // 业务库禁用与启用
  postBusinessLibIsEnable: config => createAPI('/mbd-dp-manager/businessLib/isEnable', 'post', config),
  // 新增业务库字段
  postBusinessLibFieldAdd: config => createAPI('/mbd-dp-manager/businessLib/field/add', 'post', config),
  // 修改业务库字段
  postBusinessLibFieldUpdate: config => createAPI('/mbd-dp-manager/businessLib/field/update', 'post', config),
  // 删除业务库字段
  postBusinessLibFieldDelete: config => createAPI('/mbd-dp-manager/businessLib/field/delete', 'post', config),
  // 查询业务库字段
  postBusinessLibFieldList: config => createAPI('/mbd-dp-manager/businessLib/field/list', 'post', config),
  // 查询业务库表
  postBusinessLibFindTables: config => createAPI('/mbd-dp-manager/businessLib/findTables', 'post', config),
  // 新增或修改业务库表
  postBusinessLibSaveTable: config => createAPI('/mbd-dp-manager/businessLib/saveTable', 'post', config),
  // 删除业务库表
  postBusinessLibDeleteTable: config => createAPI('/mbd-dp-manager/businessLib/deleteTable', 'post', config),
  // 查询业务库索引表
  postBusinessLibFindIndex: config => createAPI('/mbd-dp-manager/businessLib/findIndex', 'post', config),
  // 新增或修改业务库索引
  postBusinessLibSaveIndex: config => createAPI('/mbd-dp-manager/businessLib/saveIndex', 'post', config),
  // 删除业务库索引
  postBusinessLibDeleteIndex: config => createAPI('/mbd-dp-manager/businessLib/deleteIndex', 'post', config),
  // 新增或修改存储表字段
  postBusinessLibSaveTableFields: config => createAPI('/mbd-dp-manager/businessLib/saveTableFields', 'post', config),
  // 新增或修改存储表字段
  postBusinessLibFindTableFields: config => createAPI('/mbd-dp-manager/businessLib/findTableFields', 'post', config),
  // 新增或修改索引字段
  postBusinessLibSaveIndexFields: config => createAPI('/mbd-dp-manager/businessLib/saveIndexFields', 'post', config),
  // 查询索引字段
  postBusinessLibFindIndexFields: config => createAPI('/mbd-dp-manager/businessLib/findIndexFields', 'post', config),
  // 启用/禁用存储表
  postBusinessLibEnableTable: config => createAPI('/mbd-dp-manager/businessLib/enableTable', 'post', config),
  // 启用/禁用索引
  postBusinessLibEnableIndex: config => createAPI('/mbd-dp-manager/businessLib/enableIndex', 'post', config)
}
